/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

function hydrate() {
  startTransition(() => {
    try {
      hydrateRoot(
        document,
        <StrictMode>
          <RemixBrowser />
        </StrictMode>,
        {
          onRecoverableError: (error: unknown) => {
            // 捕获可恢复的错误（如 hydration 不匹配）
            console.warn('Recoverable hydration error:', error);
            
            // 对于 hydration 错误，让 React 自动恢复
            if (error instanceof Error && (error.message.includes('Hydration') || error.message.includes('hydration'))) {
              console.warn('Hydration mismatch detected, React will attempt recovery');
            }
          }
        }
      );
    } catch (error) {
      console.error('Failed to hydrate:', error);
      
      // 如果 hydration 完全失败，尝试重新渲染
      setTimeout(() => {
        console.warn('Attempting to re-hydrate after error...');
        try {
          hydrate();
        } catch (retryError) {
          console.error('Re-hydration also failed:', retryError);
        }
      }, 1000);
    }
  });
}

// 确保 DOM 完全加载后再开始 hydration
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrate);
} else {
  hydrate();
}
